import React, { useState } from 'react';
import { NavItem } from '../../config/navigationConfig.types';
import { NavAccordion } from './NavAccordion';
import { NavDirectLink } from './NavDirectLink';
import { NavTierContainer, NavListItem } from './navStyles';

interface NavTierRendererProps {
  items: NavItem[];
  tier: 1 | 2 | 3;
  isNavOpen: boolean;
  /** Optional item rendered as the first <li> of the list (e.g. Home), so it's
   * announced as part of the same list rather than a separate standalone control. */
  leadingItem?: React.ReactNode;
}

export const NavTierRenderer: React.FC<NavTierRendererProps> = ({ items, tier, isNavOpen, leadingItem }) => {
  const [openItemId, setOpenItemId] = useState<string | null>(null);

  const handleToggle = (id: string, expanded: boolean) => {
    setOpenItemId(expanded ? id : null);
  };

  return (
    <NavTierContainer tier={tier} component="ul">
      {leadingItem && <NavListItem>{leadingItem}</NavListItem>}
      {items.map(item => {
        // Branch node → Accordion
        if (item.children) {
          return (
            <NavListItem key={item.id}>
              <NavAccordion
                item={item}
                tier={tier}
                isNavOpen={isNavOpen}
                isOpen={openItemId === item.id}
                onToggle={handleToggle}
              />
            </NavListItem>
          );
        }
        // Leaf node → Direct link
        return (
          <NavListItem key={item.id}>
            <NavDirectLink
              item={item}
              tier={tier}
              isNavOpen={isNavOpen}
              onSelect={tier === 2 ? () => setOpenItemId(null) : undefined}
            />
          </NavListItem>
        );
      })}
    </NavTierContainer>
  );
};
